import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import { addbikenum, addVahanData } from "../../Redux/actions/NumBikeation";
import insurance from "../../assets/insurance.svg";
import axios from "axios";
import axiosInstance from "../../Redux/axios/AxiosInstance";
import { NavbarJourney } from "../Navbar/NavbarJourney";
import "./NuBike.css";
import bike from "../../assets/icons/bike.png";
import { Form, Input, Button, Select, Row, Col, Spin, message } from "antd/lib";
import { addbikedetails } from "../../Redux/actions/NumBikeation";

export default function Numbike() {
  const history = useHistory();
  const bikenum = useSelector((state) => state?.vehicledetail?.bikenum);
  const ProdType = useSelector((state) => state?.common?.productType);
  const BikeMakeData = useSelector(
    (state) => state?.vehicledetail?.bikeMakeData
  );
  const [formLayout] = useState("vertical");
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { Option } = Select;
  const [open, setopen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");
  const isuser = JSON.parse(localStorage.getItem("vibeUser"));

  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
  }, [BaseUrl]);
  const prefixSelector = (
    <Select
      style={{
        width: 70,
      }}
      defaultValue="+91"
    >
      <Option value="+91">+91</Option>
    </Select>
  );
  const handleClear = () => {
    form.resetFields();
  };
  const onFinish = (values) => {
    //console.log(values)
    setLoading(true);
    setopen(true);
    if (isuser !== null) {
      var is_POSP = isuser.isPOSP === true ? 1 : 0;
      var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
    } else {
      is_POSP = 0;
      posp_id = "";
    }
    const url = `${BaseUrl}v2/bike_insurances/register`;
    axios
      .post(url, {
        bike_number: values.bikeNumber,
        phonenumber: values.phonenumber,
        isPOSP: is_POSP,
        posp_id: posp_id,
      })
      .then((res) => {
        //console.log(res);
        if (res.status === 200) {
          let data = res?.data?.data;
          dispatch(addbikenum(data));
          axiosInstance
            .post("getVehicleDetails", {
              vehicleNumber: values?.bikeNumber,
            })
            .then((res) => {
              //console.log(res)
              let bikeresult = res?.data?.data;
              const { vibe_master } = bikeresult;
              dispatch(addVahanData(bikeresult));
              dispatch(
                addbikedetails({
                  ...BikeMakeData,
                  make: vibe_master?.Make,
                  model: vibe_master?.Model,
                  varbike: vibe_master?.Variant,
                  VehicleCoreCode: vibe_master?.Vehicle_Core_Code,
                })
              );
              if (ProdType === vibe_master?.Product_Type) {
                history.push("/bikedetail");
              } else {
                message.info(
                  "Entered Vehicle Number is MisMatched with Selected Product"
                );
                setLoading(false);
                setopen(false);
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        }
      })
      .catch((err) => {
        console.log(err?.response);
        setLoading(false);
        setopen(false);
      });
  };
  const onFinishFailed = (values) => {
    console.log(values);
  };
  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ bikeNumber: e.target.value });
  };

  return (
    <>
      <Spin spinning={open}>
        <NavbarJourney />
        <section
          className="bg-light d-flex align-items-center justify-content-center"
          style={{ minHeight: "calc(100vh - 50px)" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-md-6 img-0 col-sm-12  p-2">
                <div className="m-4">
                  <img
                    className="img-fluid"
                    src={insurance}
                    width={500}
                    alt=""
                  />
                </div>
              </div>
              <div className="col-xl-6 col-md-6 col-sm-12 p-2 d-flex flex-column justify-content-center align-items-center p-4 outer-insur">
                <h4 className="text-blue">
                  Save upto 85%* on Two Wheeler Insurance
                </h4>
                <p className="my-3">Stay home & renew in 2 minutes</p>
                <div className="d-flex align-items-center mt-4">
                  <img
                    alt=""
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fflash.png?alt=media&token=c7213ae8-4a09-4a72-9800-e6eb5e59ff75"
                  />
                  <small className="me-4 ms-2 text-success fw-bold">
                    Instant Policy
                  </small>
                  <img
                    alt=""
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fbank.png?alt=media&token=4cc16690-6e13-4219-a6ff-dd513fe04d1f"
                  />
                  <small className="me-4 ms-2 text-warning fw-bold">
                    Best Prices
                  </small>
                  <img
                    alt=""
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fdocuments.png?alt=media&token=7923cd01-4150-4801-a4bf-8a42120125c9"
                  />
                  <small className="me-4 ms-2 text-info fw-bold">
                    No Paperwork
                  </small>
                </div>
                <Form
                  layout={formLayout}
                  form={form}
                  style={{ width: "70%", paddingTop: "30px" }}
                  requiredMark={false}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item
                    name="bikeNumber"
                    rules={[
                      {
                        pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                        message: "Invalid Vehicle No",
                      },
                      { required: true, message: "Enter Vehicle No" },
                    ]}
                  >
                    <Input
                      onChange={handleInputChange}
                      placeholder="Enter Bike Number (eg. DL1SAB1234)"
                    ></Input>
                  </Form.Item>
                  <Form.Item
                    name="phonenumber"
                    rules={[
                      {
                        pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                        message: "Invalid Mobile No",
                      },
                      { required: true, message: "Enter Mobile No" },
                    ]}
                  >
                    <Input
                      maxLength={10}
                      addonBefore={prefixSelector}
                      placeholder="Enter Mobile Number (eg. 9876543210)"
                    ></Input>
                  </Form.Item>
                  <Row gutter={24} className="justify-content-center">
                    <Col span={12}>
                      <Form.Item>
                        <Button
                          style={{ width: "100%" }}
                          // loading={loading}
                          type="primary"
                          htmlType="submit"
                        >
                          View Price
                        </Button>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item>
                        <Button
                          className="clear-button-ant"
                          type="primary"
                          onClick={handleClear}
                        >
                          Clear
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
                <div className="h6 text-center" style={{ fontSize: "0.7rem" }}>
                  <img
                    className="mx-1"
                    style={{ maxHeight: "0.8rem" }}
                    src={bike}
                    alt=""
                  />{" "}
                  <Link
                  // to="/twoWheelMake"
                  >
                    {" "}
                    Buying a new bike?
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Spin>
    </>
  );
}
